import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CountriesEffects } from './countries/countries.effects';
import { CountryNamespace, CountryReducer } from './countries/countries.store';
import { RegionEffects } from './regions/regions.effects';
import { RegionNamespace, RegionReducer } from './regions/regions.store';

@NgModule({
  imports: [
    StoreModule.forFeature(CountryNamespace, CountryReducer),
    StoreModule.forFeature(RegionNamespace, RegionReducer),
    EffectsModule.forFeature([CountriesEffects, RegionEffects]),
  ],
})
export class LocationsDataModule {}
